export const menuData = [
    {
        title: 'Home',
        link: '/',
    },
    {
        title: "Gallery",
        link: "/gallery",
    },
    {
        title: 'Profile',
        link: '/profile',
    }
]